var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DataTable, FlexBox, IconButton } from '@dixa/lib-shared-habla';
import { useCallback, useEffect } from 'react';
import { ratingApi } from 'apis/rating';
import { appActions } from 'app/app.actions';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { isResponseWithData } from 'utils/apis/axios';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppNavigate } from 'utils/url/useAppNavigate';
export function SurveysTable() {
    var _a, _b;
    const [readRatingSettings, { data: readRatingSettingsResponse, isFetching: readRatingSettingsIsFetching, isSuccess: readRatingSettingsIsSuccess, },] = ratingApi.useLazyReadRatingSettingsQuery();
    const [deleteRatingSettings] = ratingApi.useLazyDeleteRatingSettingsQuery();
    const dispatch = useAppDispatch();
    const notify = useNotifications();
    const openDeleteModal = (ratingSettingsId) => __awaiter(this, void 0, void 0, function* () {
        const { isConfirmed } = yield dispatch(appActions.showModal({
            modal: {
                type: 'app:confirm',
                arg: {
                    title: 'Delete survey?',
                    description: 'The CSAT survey will be disabled for phone numbers associated with this survey and its language customizations will be lost.',
                    confirm: {
                        label: 'Delete',
                    },
                },
            },
        }));
        if (isConfirmed) {
            try {
                const deleteResponse = yield deleteRatingSettings({
                    ratingSettingsId: ratingSettingsId,
                }).unwrap();
                if (isResponseWithData(deleteResponse)) {
                    readSurveys();
                }
                notify({
                    title: 'Success',
                    text: `The survey has been deleted.`,
                    icon: 'done',
                    time: 5000,
                }, NotificationType.Success);
            }
            catch (error) {
                notify({
                    title: 'Error while deleting survey.',
                }, NotificationType.Error);
            }
        }
    });
    const readSurveys = useCallback(() => {
        return readRatingSettings({
            level: 'survey',
            surveyType: 'text_to_speech',
        });
    }, [readRatingSettings]);
    useEffect(() => {
        readSurveys();
    }, [readSurveys]);
    const navigate = useAppNavigate();
    const handleGoToSurvey = useCallback((settingsId) => {
        navigate({
            path: '/settings/satisfaction/phone/survey/:settingsId',
            params: { path: { settingsId } },
        });
    }, [navigate]);
    return (_jsx(DataTable, { data: (_a = readRatingSettingsResponse === null || readRatingSettingsResponse === void 0 ? void 0 : readRatingSettingsResponse.data.rating_settings) !== null && _a !== void 0 ? _a : [], tableLoadingStrategy: "spinner", tableStatusProps: {
            loading: readRatingSettingsIsFetching,
            loadingFailed: !readRatingSettingsIsSuccess,
            emptyState: readRatingSettingsIsSuccess &&
                ((_b = readRatingSettingsResponse === null || readRatingSettingsResponse === void 0 ? void 0 : readRatingSettingsResponse.data.rating_settings) !== null && _b !== void 0 ? _b : []).length < 1
                ? {
                    title: 'No configured surveys',
                    description: 'Click "Add survey" to set up a new CSAT survey.',
                }
                : undefined,
        }, columns: [
            {
                label: 'Name',
                selector: ({ name }) => name,
            },
            {
                label: '',
                selector: ({ id }) => (_jsxs(FlexBox, Object.assign({ flexDirection: "row" }, { children: [_jsx(IconButton, { variant: "tertiary", icon: "pen", onClick: () => handleGoToSurvey(id) }), _jsx(IconButton, { variant: "tertiary", icon: "trash", onClick: () => openDeleteModal(id) })] }))),
                style: {
                    width: 0,
                },
            },
        ] }));
}
